export function useIsLocal() {
  return process.env.REACT_APP_VERCEL_ENV === undefined || process.env.REVIEW_APP === "true";
}
